import { datadogRum } from "@datadog/browser-rum";
import { useAtomValue, useSetAtom } from "jotai";
import { useQuery } from "react-query";

import { getEstimate } from "api/getEstimate";
import { estimateAtom } from "atoms/estimate";
import { sessionIdAtom } from "atoms/sessionId";

import { clientIdAtom } from "../../../atoms/clientId";


export const usePullEstimate = (enablePayeeJourney: boolean) => {
  const sessionId = useAtomValue(sessionIdAtom);
  const clientId = useAtomValue(clientIdAtom);
  const setEstimate = useSetAtom(estimateAtom);
  useQuery("estimate", () => getEstimate(sessionId, clientId), {
        enabled: enablePayeeJourney,
        refetchOnMount: true,
        refetchOnWindowFocus: true,
        onSuccess: ({ estimate }) => {
            if (estimate !== null) {
                datadogRum.addAction("Received Payee Estimate", { timestamp: Date.now() });
                setEstimate(estimate);
            }
        },
        onError: (error) => {
            datadogRum.addError(error, {
                message: "Failed to get payee estimate",
            });
        },
    });
};
